import { isAuthenticated } from "../services/authService";
import { useAuth } from "../hooks/Auth";
import { Navigate } from "react-router-dom";


export default function SafeAccess({ allowedRoles, children, fallback = null }) {
    const { getUserPerfil } = useAuth()
    const userRole = getUserPerfil();
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(userRole)) {
        return fallback || <Navigate to="/home" replace />;
    }

    return allowedRoles.includes(userRole) ? children : fallback;
};